<app-modal-wrapper class="w-full h-full flex-auto"
    [title]="'Descarga la App'"
    [showDeleteButton]="false"
    [showMarginBody]="false"
    [triggerCloseService]="false"
    [showFooter]="false"
    [showOkButton]="false"
    (onRequireClose)="onClose()">

    <ng-container sidebarFormBodyContent>
        <div class="flex flex-col items-center space-y-6">
            <!-- Icono de Google Play -->
            <div class="flex items-center justify-center" (onClick)="downloadApp()">
                <mat-icon svgIcon="google-play-badge-logo" class="text-background w-32 h-32"></mat-icon>
            </div>
            
            <!-- Mensaje -->
            <div class="text-gray-300 text-center">
                Obtén la mejor experiencia con nuestra App.
            </div>
            
            <!-- Botones -->
            <div class="flex flex-col gap-16 w-full items-center">
                <!-- Botón Descargar desde Play Store -->
                <standard-button 
                    class="w-full"
                    (onClick)="downloadApp()" 
                    [extendedClass]="'w-full'" 
                    [text]="'Descargar'">
                </standard-button>
                
                <!-- Link para Continuar en Web -->
                <a 
                    (click)="continueWeb()" 
                    class="text-white text-sm underline font-extralight cursor-pointer hover:text-white/80 transition-colors">
                    Continuar en la web (Más lento)
                </a>
            </div>
        </div>
    </ng-container>
</app-modal-wrapper>
